const {
  GraphQLRequestClient,
  getEdgeProxyContentUrl,
} = require('@sitecore-jss/sitecore-jss-nextjs/graphql');

/**
 * Creates a new GraphQLRequestClientFactory instance
 * @param {object} config - JSS config
 * @returns GraphQLRequestClientFactory instance
 */
const createGraphQLJavaScriptClientFactory = (config) => {
  let clientConfig;

  if (config.sitecoreEdgeContextId) {
    clientConfig = {
      endpoint: getEdgeProxyContentUrl(config.sitecoreEdgeContextId, config.sitecoreEdgeUrl),
    };
  } else if (config.graphQLEndpoint && config.sitecoreApiKey) {
    clientConfig = {
      endpoint: config.graphQLEndpoint,
      apiKey: config.sitecoreApiKey,
    };
  } else {
    throw new Error(
      'Please configure either your sitecoreEdgeContextId, or your graphQLEndpoint and sitecoreApiKey.'
    );
  }
  return GraphQLRequestClient.createClientFactory(clientConfig);
};

module.exports = { createGraphQLJavaScriptClientFactory };
